import { queryKey } from '../../../utils/queryUtils';

export const continueWatchingKey = queryKey('ats-continue-watching');

export const bookmarksTitlesKey = queryKey('bookmarks-titles');
